module.exports = __webpack_public_path__ + "fonts/RenaultLife-Light.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Light.eot
// module id = 359
// module chunks = 0